import React, {useState} from 'react';

import classNames from 'classnames';
import {useDispatch} from 'react-redux';

import {
    setSaveCardChecked as setSaveCardCheckedAction,
    setVaultPaymentId as setVaultPaymentIdAction,
} from 'desktop/pages/checkout/store/reducers/primer/primer';

import {PaymentFooter} from '../../../paymentFooter/paymentFooter';
import {PrimerForm} from '../../../paymentPrimerCreditCard/components/primerForm/primerForm';
import {SaveCardCheckboxConnected} from '../../../paymentPrimerCreditCard/components/saveCardCheckbox/saveCardCheckbox';
import {SavedCardsSwitcher} from '../../../paymentPrimerCreditCard/components/savedCardsSwitcher/savedCardsSwitcher';
import {defaultErrorState} from '../../../paymentPrimerCreditCard/constants';
import {usePrimerCreditCard} from '../../../paymentPrimerCreditCard/hooks/usePrimerCreditCard';
import {PaymentWrapper} from '../../common/paymentWrapper/paymentWrapper';

import {PrimerError} from '../../common/primerError/primerError';

import {SavedCards} from './savedCards/savedCards';

import {usePrimerCreditCardState} from './usePrimerCreditCardState';

import s from './paymentPrimerCreditCardOneStep.scss';

/**
 * Primer credit card one step
 */
export const PaymentPrimerCreditCardOneStep = () => {
    const dispatch = useDispatch();

    const {hasVaultedCards, isLoadingCreditCard, isLoadingPaymentMethods, vaultedPaymentMethods} =
        usePrimerCreditCardState();

    const [isReady, setIsReady] = useState(false);
    const {cardNetwork, primerError, setPrimerError, submitForm} = usePrimerCreditCard({
        onReady: () => setIsReady(true),
    });

    const [showSavedCards, setShowSavedCards] = useState(true);
    const onSavedCardToggle = () => {
        const newShowSavedCards = !showSavedCards;
        dispatch(setVaultPaymentIdAction(''));
        dispatch(setSaveCardCheckedAction(false));
        setShowSavedCards(newShowSavedCards);
        setPrimerError(defaultErrorState);
    };

    const showCardsListComponent = hasVaultedCards && showSavedCards;

    const isLoading = isLoadingPaymentMethods || !isReady;

    const renderVaultedCardsToggle = () =>
        hasVaultedCards && (
            <SavedCardsSwitcher isSavedCardsShown={showSavedCards} onChange={onSavedCardToggle} />
        );

    return (
        <>
            <PaymentWrapper showSkeleton={isLoading} isCreditCard>
                <div className={s.paymentContainer}>
                    {isReady && showCardsListComponent && (
                        <>
                            <SavedCards
                                primerError={primerError}
                                vaultedPaymentMethods={vaultedPaymentMethods}
                            />
                            {renderVaultedCardsToggle()}
                        </>
                    )}

                    <div
                        className={classNames(s.formWrapper, {
                            [s.hide]: !isReady || showCardsListComponent,
                        })}
                    >
                        <PrimerForm cardNetwork={cardNetwork} isReady={isReady} />
                        {isReady && (
                            <>
                                <PrimerError primerError={primerError} />
                                <SaveCardCheckboxConnected />
                                {renderVaultedCardsToggle()}
                            </>
                        )}
                    </div>
                </div>
            </PaymentWrapper>

            <div className={s.paymentFooter}>
                <PaymentFooter
                    isLoading={isLoadingCreditCard}
                    isOneStepLoading={isLoading}
                    onSubmit={submitForm}
                />
            </div>
        </>
    );
};
